<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-dialog
        v-model="cnpjWarningDialog"
        max-width="520"
        transition="dialog-scale-transition"
      >
        <v-card class="pa-6 elevation-10 cnpj-warning-card">
          <v-card-title class="d-flex align-center pa-0 mb-3">
            <v-icon
              color="warning"
              size="32"
              class="mr-3 cnpj-warning-icon"
            >
              mdi-alert-circle-outline
            </v-icon>
            <span class="text-h6 font-weight-medium cnpj-warning-title warning--text text--darken-1">Atenção</span>
          </v-card-title>
          <v-divider class="mb-4"></v-divider>
          <v-card-text class="pt-0 cnpj-warning-text">
            <p class="mb-2">
              Importamos as informações desta empresa automaticamente pelo serviço de CNPJ.
            </p>
            <p class="mb-0 font-italic secondary--text text--darken-2">
              Confira se os dados ainda estão corretos antes de salvar.
            </p>
          </v-card-text>
          <v-card-actions class="justify-end pt-4">
            <v-btn
              color="primary"
              dark
              class="px-6"
              @click="cnpjWarningDialog = false"
            >
              Entendi
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- <div class="title_body">
            <span class="text_title">{{ title }}</span>
            <span class="btn_close">
                <v-btn icon small @click="dialog = false">
                    <v-icon dark> {{ icons.mdiClose }} </v-icon>
                </v-btn>
            </span>
        </div> -->
      <BarTitleDialog
        :title="title"
        @close="close"
      />

      <v-card-text>
        <v-container>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  x-large
                  color="blue darken-1"
                  class="mr-2"
                  text
                  @click="close"
                >
                  Fechar
                </v-btn>
                <v-btn
                  x-large
                  :loading="loading"
                  color="primary"
                  @click="save"
                >
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>

          <fieldset
            :disabled="!canEditGeneral"
            class="form-fieldset"
          >
            <v-row
              no-gutters
              class="mt-2"
            >
              <v-col cols="4">
                <v-text-field
                  v-model="nameFantasy"
                  outlined
                  label="Nome Fantasia"
                  :hide-details="true"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="razaoSocial"
                  class="ml-2"
                  outlined
                  label="Razão Social"
                  :hide-details="true"
                ></v-text-field>
              </v-col>
              <v-col cols="">
                <v-text-field
                  v-model="editedItem.cpf_cnpj"
                  v-mask="'##.###.###/####-##'"
                  class="ml-2"
                  outlined
                  label="CPF/CNPJ"
                  :hide-details="true"
                  :loading="cnpjLoading"
                  @blur="canEditGeneral ? fetchCompanyByCnpj() : null"
                ></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-checkbox
                  v-model="Inactive"
                  class="ml-2"
                  label="Inativo"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>

            <v-row
              no-gutters
              class="mt-4"
            >
              <v-col>
                <v-text-field
                  v-model="editedItem.state_registration"
                  outlined
                  label="Inscrição Estadual"
                  :hide-details="true"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-select
                  v-model="editedItem.situation"
                  class="ml-2"
                  :items="situation_items"
                  item-value="id"
                  item-text="name"
                  outlined
                  hide-details
                  label="Situação"
                ></v-select>
              </v-col>
              <v-col>
                <v-select
                  v-model="editedItem.type"
                  class="ml-2"
                  :items="type_items"
                  item-value="id"
                  item-text="name"
                  outlined
                  hide-details
                  label="Tipo"
                ></v-select>
              </v-col>
              <v-col>
                <v-select
                  v-model="editedItem.category"
                  class="ml-2"
                  :items="category_items"
                  item-value="id"
                  item-text="name"
                  outlined
                  hide-details
                  label="Categoria"
                ></v-select>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="4">
                <v-checkbox
                  v-model="Incomplete_registration"
                  class="ml-2"
                  label="Cadastro Incompleto"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox
                  v-model="Issue_nfc_e"
                  label="Emite NFC-e"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox
                  v-model="Issue_cf_e_sat"
                  label="Emite CF-e-SAT"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="4">
                <v-checkbox
                  v-model="Room_night"
                  class="ml-2"
                  label="Programa de fidelidade por room night"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox
                  v-model="Block_release"
                  label="Bloquear Lançamento"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col>
                <v-checkbox
                  v-model="Cob"
                  label="COB"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
          </fieldset>
          <v-row class="mt-4">
            <v-col>
              <v-card
                flat
                outlined
              >
                <v-tabs v-model="tab">
                  <v-tab>Endereço</v-tab>
                  <v-tab>Tarifas e Faturamento</v-tab>
                  <v-tab>Contatos</v-tab>
                  <v-tab>Motor de Reservas</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                  <!-- ENDEREÇO -->
                  <v-tab-item>
                    <v-card
                      flat
                      class="card-tab"
                    >
                      <v-card-text>
                        <fieldset
                          :disabled="!canEditGeneral"
                          class="form-fieldset"
                        >
                          <v-row
                            no-gutters
                            class="mt-2"
                          >
                            <v-col cols="5">
                              <v-text-field
                                v-model="editedItem.address"
                                outlined
                                hide-details
                                label="Endereço"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                              <v-text-field
                                v-model="editedItem.number"
                                outlined
                                hide-details
                                label="Número"
                                class="ml-2"
                              ></v-text-field>
                            </v-col>
                            <v-col class="ml-2">
                              <v-text-field
                                v-model="editedItem.complement"
                                outlined
                                hide-details
                                label="Complemento"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row
                            no-gutters
                            class="mt-2"
                          >
                            <v-col cols="3">
                              <v-text-field
                                v-model="editedItem.neighborhood"
                                outlined
                                hide-details
                                label="Bairro"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-select
                                v-model="editedItem.country_id"
                                class="ml-2"
                                :items="country_items"
                                item-value="id"
                                item-text="name"
                                outlined
                                hide-details
                                label="País"
                              ></v-select>
                            </v-col>
                            <v-col
                              class="ml-2"
                              cols="3"
                            >
                              <v-text-field
                                v-model="editedItem.zipcode"
                                v-mask="'##.###-###'"
                                outlined
                                hide-details
                                label="CEP"
                                @input="getCEP"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="">
                              <v-select
                                v-model="editedItem.state_id"
                                class="ml-2"
                                :items="state_items"
                                item-value="id"
                                item-text="name"
                                outlined
                                hide-details
                                label="UF"
                                @change="loadCities()"
                              ></v-select>
                            </v-col>
                          </v-row>

                          <v-row
                            no-gutters
                            class="mt-2"
                          >
                            <v-col cols="3">
                              <v-select
                                v-model="editedItem.city_id"
                                :items="city_items"
                                item-value="id"
                                item-text="name"
                                outlined
                                hide-details
                                label="Cidade"
                              ></v-select>
                            </v-col>
                            <!-- <v-col class="ml-2" cols="2">
                                                    <v-text-field v-model="editedItem.ibge_code"  outlined hide-details label="Cod. IBGE"></v-text-field>
                                                </v-col> -->
                            <v-col cols="2">
                              <v-text-field
                                v-model="editedItem.home_phone"
                                v-mask="'(##)####-####'"
                                class="ml-2"
                                outlined
                                hide-details
                                label="Fone Res."
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="2"
                              class="ml-2"
                            >
                              <v-text-field
                                v-model="editedItem.commercial_phone"
                                v-mask="'(##)####-####'"
                                outlined
                                hide-details
                                label="Fone Com."
                              ></v-text-field>
                            </v-col>
                            <v-col class="ml-2">
                              <v-text-field
                                v-model="editedItem.cell_phone"
                                v-mask="'(##)#####-####'"
                                outlined
                                hide-details
                                label="Celular"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row
                            no-gutters
                            class="mt-2"
                          >
                            <v-col cols="2">
                              <v-text-field
                                v-model="editedItem.fax_phone"
                                v-mask="'(##)####-####'"
                                outlined
                                hide-details
                                label="Fax"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="email"
                                class="ml-2"
                                outlined
                                hide-details
                                label="Email"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="">
                              <v-text-field
                                v-model="editedItem.home_page"
                                class="ml-2"
                                outlined
                                hide-details
                                label="Home Page"
                              ></v-text-field>
                            </v-col>
                            <!-- <v-col>
                                                    <v-text-field class="ml-2" v-model="editedItem.ibge"  outlined hide-details label="IBGE"></v-text-field>
                                                </v-col> -->
                          </v-row>
                          <v-row
                            no-gutters
                            class="mt-2"
                          >
                          </v-row>
                          <v-row
                            no-gutters
                            class="mt-2"
                          >
                          </v-row>
                        </fieldset>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card
                      flat
                      class="card-tab"
                    >
                      <v-card-text>
                        <v-row>
                          <v-col cols="4">
                            <v-autocomplete
                              v-model="editedItem.rate_plan_id"
                              :items="ratePlans"
                              item-value="id"
                              item-text="description"
                              label="Tarifário"
                              outlined
                              dense
                              hide-details
                              clearable
                            />
                          </v-col>
                        </v-row>
                        <v-divider class="my-4"></v-divider>
                        <div class="text-subtitle-2 mb-3">
                          Faturamento (sincronizado da API)
                        </div>
                        <v-row>
                          <v-col
                            cols="4"
                            class="d-flex align-center"
                          >
                            <v-checkbox
                              v-model="Allow_billing"
                              label="Permitir faturamento"
                              color="primary"
                              hide-details
                              class="mt-0"
                              disabled
                            ></v-checkbox>
                          </v-col>
                          <v-col
                            v-if="Allow_billing"
                            cols="4"
                          >
                            <v-text-field
                              v-model="editedItem.billing_limit"
                              outlined
                              dense
                              type="number"
                              step="0.01"
                              min="0"
                              label="Limite total de faturamento"
                              prefix="R$"
                              hide-details
                              readonly
                            ></v-text-field>
                          </v-col>
                          <v-col
                            v-if="Allow_billing"
                            cols="4"
                          >
                            <v-text-field
                              :value="formatMoneyBR(companyCredit.available)"
                              outlined
                              dense
                              label="Saldo disponível"
                              hide-details
                              readonly
                              :loading="loadingCompanyCredit"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row
                          v-if="Allow_billing && !loadingCompanyCredit"
                          class="mt-2"
                        >
                          <v-col cols="12">
                            <v-alert
                              v-if="companyCredit.billing_blocked"
                              type="error"
                              dense
                              outlined
                              class="mb-2"
                            >
                              <strong>Faturamento bloqueado</strong> — empresa possui faturas vencidas há {{ companyCredit.overdue_days }} dia{{ companyCredit.overdue_days !== 1 ? 's' : '' }}.
                            </v-alert>
                            <div
                              v-if="editedItem.billing_limit"
                              class="d-flex align-center"
                            >
                              <span
                                class="caption grey--text mr-2"
                                style="white-space:nowrap"
                              >
                                {{ formatMoneyBR(companyCredit.consumed) }} / {{ formatMoneyBR(editedItem.billing_limit) }}
                              </span>
                              <v-progress-linear
                                :value="creditUsagePercent"
                                :color="creditBarColor"
                                height="10"
                                rounded
                                class="flex-grow-1"
                              ></v-progress-linear>
                              <span
                                class="caption ml-2"
                                :class="`${creditBarColor}--text`"
                              >
                                {{ creditUsagePercent }}%
                              </span>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <!-- CONTATOS -->
                  <v-tab-item>
                    <v-card
                      flat
                      class="card-tab"
                    >
                      <v-card-text>
                        <v-row>
                          <v-col>
                            <v-btn
                              color="primary"
                              :disabled="contacts.length >= 10"
                              @click="addContact"
                            >
                              <v-icon left>
                                {{ icons.mdiPlus }}
                              </v-icon>
                              Adicionar Contato
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row
                          v-for="(contact, index) in contacts"
                          :key="index"
                          class="mt-2"
                        >
                          <v-col cols="2">
                            <v-text-field
                              v-model="contact.name"
                              outlined
                              dense
                              hide-details
                              label="Nome"
                              placeholder="Nome do contato"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-text-field
                              v-model="contact.email"
                              outlined
                              dense
                              hide-details
                              label="Email"
                              type="email"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field
                              v-model="contact.mobile_phone"
                              v-mask="['(##)#####-####']"
                              outlined
                              dense
                              hide-details
                              label="Celular"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field
                              v-model="contact.landline_phone"
                              v-mask="['(##)####-####']"
                              outlined
                              dense
                              hide-details
                              label="Telefone Fixo"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field
                              v-model="contact.sector"
                              outlined
                              dense
                              hide-details
                              label="Setor"
                              placeholder="Ex: Financeiro, Comercial"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="1"
                            class="d-flex align-center justify-center"
                          >
                            <v-btn
                              icon
                              color="error"
                              small
                              @click="removeContact(index)"
                            >
                              <v-icon>{{ icons.mdiDeleteOutline }}</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row
                          v-if="contacts.length === 0"
                          class="mt-4"
                        >
                          <v-col class="text-center grey--text">
                            Nenhum contato adicionado. Clique em "Adicionar Contato" para começar.
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <!-- MOTOR DE RESERVAS -->
                  <v-tab-item>
                    <v-card
                      flat
                      class="card-tab"
                    >
                      <v-card-text>
                        <v-row>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-card
                              outlined
                              class="pa-4"
                            >
                              <div class="d-flex align-center mb-2">
                                <v-icon
                                  color="primary"
                                  class="mr-2"
                                >
                                  mdi-domain
                                </v-icon>
                                <span class="text-subtitle-1 font-weight-medium">Motor de Reservas Empresarial</span>
                                <v-spacer></v-spacer>
                                <v-chip
                                  small
                                  :color="bookingEngineUser && bookingEngineUser.is_active ? 'success' : 'grey'"
                                  dark
                                >
                                  {{ bookingEngineUser && bookingEngineUser.is_active ? 'Ativo' : 'Inativo' }}
                                </v-chip>
                              </div>

                              <v-switch
                                :input-value="engineSwitchState"
                                label="Ativar Motor de Reservas"
                                color="success"
                                :disabled="bookingEngineLoading"
                                hide-details
                                inset
                                class="mb-2"
                                @change="handleEngineSwitch"
                              ></v-switch>

                              <v-tooltip
                                bottom
                                :disabled="Allow_billing"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <div v-on="on">
                                    <v-switch
                                      v-model="BookingEngineBillingEnabled"
                                      label="Disponibilizar pagamento faturado"
                                      color="success"
                                      :disabled="!Allow_billing"
                                      hide-details
                                      inset
                                      class="mb-4"
                                    ></v-switch>
                                  </div>
                                </template>
                                <span>Faturamento não habilitado para esta empresa no sistema de gestão</span>
                              </v-tooltip>

                              <v-tooltip
                                bottom
                                :disabled="Allow_billing && BookingEngineBillingEnabled"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <div v-on="on">
                                    <v-switch
                                      v-model="BookingEngineShowBillingBalance"
                                      label="Mostrar saldo/limite no motor"
                                      color="success"
                                      :disabled="!Allow_billing || !BookingEngineBillingEnabled"
                                      hide-details
                                      inset
                                      class="mb-4"
                                    ></v-switch>
                                  </div>
                                </template>
                                <span>Disponível apenas com faturamento habilitado no motor</span>
                              </v-tooltip>

                              <v-text-field
                                v-model="bookingEngineEmail"
                                outlined
                                dense
                                hide-details="auto"
                                label="E-mail de acesso"
                                type="email"
                                :disabled="bookingEngineLoading"
                                class="mb-3"
                              ></v-text-field>

                              <template v-if="!bookingEngineUser || !bookingEngineUser.is_active">
                                <v-btn
                                  color="success"
                                  block
                                  :loading="bookingEngineLoading"
                                  :disabled="!bookingEngineEmail"
                                  @click="doCreateAndActivateBookingEngine"
                                >
                                  <v-icon left>
                                    mdi-rocket-launch-outline
                                  </v-icon>
                                  Ativar e enviar credenciais
                                </v-btn>
                              </template>

                              <template v-else>
                                <v-btn
                                  color="primary"
                                  block
                                  class="mb-2"
                                  :loading="bookingEngineLoading"
                                  :disabled="!bookingEngineEmail"
                                  @click="doUpdateBookingEngineEmail"
                                >
                                  <v-icon left>
                                    mdi-account-edit-outline
                                  </v-icon>
                                  Trocar e-mail de acesso
                                </v-btn>

                                <v-btn
                                  outlined
                                  block
                                  small
                                  color="primary"
                                  :loading="bookingEngineResendLoading"
                                  @click="doResendBookingEnginePassword"
                                >
                                  <v-icon
                                    left
                                    small
                                  >
                                    mdi-email-sync-outline
                                  </v-icon>
                                  Reenviar senha
                                </v-btn>
                              </template>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import {
  mdiClose,
  mdiDeleteOutline,
  mdiPencilOutline,
  mdiPlus,
} from '@mdi/js'

import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'

import BarTitleDialog from '@/components/BarTitleDialog.vue'

export default {

  components: {
    BarTitleDialog,
  },
  props: {
    value: {
      type: Boolean,
    },
    in_data: {
      type: Object,
    }, // recebe os dados do hospede
    title: {
      type: String,
    },
    view_mode: {
      type: Boolean,
      default: false,
    },

  },
  data: () => ({
    ratePlans: [],
    dialogDelete: false,
    dialog: false,
    loading: false,
    cnpjLoading: false,
    cnpjWarningDialog: false,
    bookingEngineUser: null,
    bookingEngineEmail: '',
    bookingEngineLoading: false,
    bookingEngineResendLoading: false,
    engineSetupMode: false,
    engineSwitchState: false,
    loadingCompanyCredit: false,
    companyCredit: {
      available: 0,
      consumed: 0,
      billing_blocked: false,
      overdue_days: 0,
    },
    country_items: [],
    state_items: [],
    city_items: [],
    contacts: [],
    headers: [{
      text: 'ID',
      align: 'start',
      value: 'id',
    },
    {
      text: 'PERFIL',
      value: 'name',
    },
    {
      text: '',
      align: 'end',
      value: 'actions',
      sortable: false,
    },
    ],
    familiars: [],
    editedItem: {
      razao_social: '',
      fantasy_name: '',
      allow_billing: 0,
      billing_limit: null,
      booking_engine_show_billing_balance: true,
      incomplete_registration: 'not',
      cpf_cnpj: '',
      situation: '',
      type: '',
      inactive: 'not',
      issue_nfc_e: 'not',
      issue_cf_e_sat: 'not',
      room_night: 'not',
      block_release: 'not',
      cob: 'not',
      address: '',
      number: '',
      neighborhood: '',
      country_id: '',
      zipcode: '',
      state_id: '',
      city_id: '',
      ibge_code: '',
      home_phone: '',
      commercial_phone: '',
      cell_phone: '',
      fax_phone: '',
      email: '',
      home_page: '',
      ibge: '',
    },
    defaultItem: {
      razao_social: '',
      fantasy_name: '',
      allow_billing: 0,
      billing_limit: null,
      booking_engine_show_billing_balance: true,
      incomplete_registration: 'not',
      cpf_cnpj: '',
      situation: '',
      type: '',
      inactive: 'not',
      issue_nfc_e: 'not',
      issue_cf_e_sat: 'not',
      room_night: 'not',
      block_release: 'not',
      cob: 'not',
      address: '',
      number: '',
      neighborhood: '',
      country_id: '',
      zipcode: '',
      state_id: '',
      city_id: '',
      ibge_code: '',
      home_phone: '',
      commercial_phone: '',
      cell_phone: '',
      fax_phone: '',
      email: '',
      home_page: '',
      ibge: '',
    },
    situation_items: [{
      id: 1,
      name: 'Faturamento livre',
    },
    {
      id: 2,
      name: 'Faturamento bloqueado',
    },

    ],
    type_items: [{
      id: 1,
      name: 'Empresa',
    }],
    category_items: [{
      id: 1,
      name: 'Privada',
    }],
    options: {},
    tab: null,
    icons: {
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiPlus,
      mdiClose,
    },
  }),

  watch: {
    value(val) {
      this.dialog = val
      if (val) {
        this.tab = this.view_mode ? 1 : 0
        this.inicialize()
      }
    },
    dialog(val) {
      this.$emit('input', val)
      if (!val) {
        this.close()
      }
    },
    in_data(val) {
      this.editedItem = {
        booking_engine_show_billing_balance: true,
        ...val,
      }

      // Carrega os contatos se existirem
      if (val && val.contacts && Array.isArray(val.contacts)) {
        this.contacts = val.contacts.map(contact => ({
          sector: contact.sector || '',
          name: contact.name || '',
          email: contact.email || '',
          mobile_phone: contact.mobile_phone || '',
          landline_phone: contact.landline_phone || '',
        }))
      } else {
        this.contacts = []
      }

      this.syncCompanyCredit()
      this.fetchBookingEngineUser()
    },
    'editedItem.allow_billing': function () {
      this.syncCompanyCredit()
    },

  },

  created() {
    this.loadRatePlans().then(res => { this.ratePlans = res.data })
  },

  computed: {
    ...mapGetters('guest', ['getFamiliars']),
    nameFantasy: {
      get() {
        return this.editedItem.fantasy_name
      },
      set(val) {
        if (!val) {
          this.editedItem.fantasy_name = ''

          return
        }
        this.editedItem.fantasy_name = val[0].toUpperCase() + val.substring(1)
      },
    },
    razaoSocial: {
      get() {
        return this.editedItem.razao_social
      },
      set(val) {
        if (!val) {
          this.editedItem.razao_social = ''

          return
        }
        this.editedItem.razao_social = val[0].toUpperCase() + val.substring(1)
      },
    },
    email: {
      get() {
        return this.editedItem.email
      },
      set(val) {
        this.editedItem.email = val.toLowerCase()
      },
    },

    Inactive: {
      get() {
        if (this.editedItem.inactive == 'yes') {
          return true
        }

        return false
      },
      set(val) {
        if (val == true) {
          this.editedItem.inactive = 'yes'
        } else {
          this.editedItem.inactive = 'not'
        }
      },

    },
    Issue_nfc_e: {
      get() {
        if (this.editedItem.issue_nfc_e == 'yes') {
          return true
        }

        return false
      },
      set(val) {
        if (val == true) {
          this.editedItem.issue_nfc_e = 'yes'
        } else {
          this.editedItem.issue_nfc_e = 'not'
        }
      },

    },
    Issue_cf_e_sat: {
      get() {
        if (this.editedItem.issue_cf_e_sat == 'yes') {
          return true
        }

        return false
      },
      set(val) {
        if (val == true) {
          this.editedItem.issue_cf_e_sat = 'yes'
        } else {
          this.editedItem.issue_cf_e_sat = 'not'
        }
      },

    },
    Room_night: {
      get() {
        if (this.editedItem.room_night == 'yes') {
          return true
        }

        return false
      },
      set(val) {
        if (val == true) {
          this.editedItem.room_night = 'yes'
        } else {
          this.editedItem.room_night = 'not'
        }
      },
    },
    Block_release: {
      get() {
        if (this.editedItem.block_release == 'yes') {
          return true
        }

        return false
      },
      set(val) {
        if (val == true) {
          this.editedItem.block_release = 'yes'
        } else {
          this.editedItem.block_release = 'not'
        }
      },
    },
    Cob: {
      get() {
        if (this.editedItem.cob == 'yes') {
          return true
        }

        return false
      },
      set(val) {
        if (val == true) {
          this.editedItem.cob = 'yes'
        } else {
          this.editedItem.cob = 'not'
        }
      },
    },
    Incomplete_registration: {
      get() {
        if (this.editedItem.incomplete_registration == 'yes') {
          return true
        }

        return false
      },
      set(val) {
        if (val == true) {
          this.editedItem.incomplete_registration = 'yes'
        } else {
          this.editedItem.incomplete_registration = 'not'
        }
      },
    },
    Allow_billing: {
      get() {
        return Number(this.editedItem.allow_billing || 0) === 1
      },
      set(val) {
        this.editedItem.allow_billing = val ? 1 : 0
        if (!val) {
          this.editedItem.billing_limit = null
          this.editedItem.booking_engine_billing_enabled = false
          this.editedItem.booking_engine_show_billing_balance = false
        }
      },
    },
    BookingEngineBillingEnabled: {
      get() {
        return !!this.editedItem.booking_engine_billing_enabled
      },
      set(val) {
        this.editedItem.booking_engine_billing_enabled = !!val
        if (!this.editedItem.booking_engine_billing_enabled) {
          this.editedItem.booking_engine_show_billing_balance = false
        }
      },
    },
    BookingEngineShowBillingBalance: {
      get() {
        return !!this.editedItem.booking_engine_show_billing_balance
      },
      set(val) {
        this.editedItem.booking_engine_show_billing_balance = !!val
      },
    },
    canEditGeneral() {
      return !this.view_mode
    },
    creditUsagePercent() {
      const limit = Number(this.editedItem.billing_limit || 0)
      if (!limit) return 0

      return Math.min(100, Math.round((this.companyCredit.consumed / limit) * 100))
    },
    creditBarColor() {
      if (this.companyCredit.billing_blocked) return 'error'
      if (this.creditUsagePercent >= 90) return 'error'
      if (this.creditUsagePercent >= 70) return 'warning'

      return 'success'
    },

  },

  methods: {
    ...mapActions('company', ['store', 'update', 'getCompanyCredit', 'getBookingEngineUser', 'saveBookingEngineEmail', 'toggleBookingEngine', 'resendBookingEnginePassword']),
    ...mapActions('select', ['get_countries', 'get_states', 'get_cities']),
    ...mapActions('rate_plan', { loadRatePlans: 'getForSelect' }),
    inicialize() {
      this.get_countries().then(response => {
        this.country_items = response.data
      })

      this.get_states().then(response => {
        this.state_items = response.data
        if (this.editedItem.state_id) {
          this.loadCities()
        }
      })

      this.syncCompanyCredit()
    },
    formatMoneyBR(value) {
      const amount = Number(value || 0)

      return amount.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })
    },
    syncCompanyCredit() {
      if (!this.editedItem?.id || !this.Allow_billing) {
        this.companyCredit = {
          available: 0, consumed: 0, billing_blocked: false, overdue_days: 0,
        }
        this.loadingCompanyCredit = false

        return
      }

      this.loadingCompanyCredit = true
      this.getCompanyCredit(this.editedItem.id)
        .then(({ data }) => {
          const creditData = data?.data || {}
          this.companyCredit = {
            available: Number(creditData.available || 0),
            consumed: Number(creditData.consumed || 0),
            billing_blocked: Boolean(creditData.billing_blocked),
            overdue_days: Number(creditData.overdue_days || 0),
          }
        })
        .catch(() => {
          this.companyCredit = {
            available: 0, consumed: 0, billing_blocked: false, overdue_days: 0,
          }
        })
        .finally(() => {
          this.loadingCompanyCredit = false
        })
    },
    fetchCompanyByCnpj() {
      if (this.editedItem?.id) {
        return
      }

      const cnpj = (this.editedItem.cpf_cnpj || '').replace(/\D/g, '')
      if (cnpj.length !== 14) {
        return
      }

      this.cnpjLoading = true
      axios.get(`https://minhareceita.org/${cnpj}`)
        .then(({ data }) => {
          this.populateCompanyFromCnpj(data)
        })
        .catch(() => {
          if (this.$toast) {
            this.$toast.error('CNPJ não encontrado ou serviço indisponível')
          }
        })
        .finally(() => {
          this.cnpjLoading = false
        })
    },
    populateCompanyFromCnpj(data) {
      if (!data) {
        return
      }

      if (data.nome_fantasia) {
        this.nameFantasy = data.nome_fantasia
      }

      if (data.razao_social) {
        this.razaoSocial = data.razao_social
      }

      if (data.email) {
        this.email = data.email
      }

      if (data.numero) {
        this.editedItem.number = data.numero
      }

      if (typeof data.complemento === 'string') {
        this.editedItem.complement = data.complemento
      }

      const commercialPhone = this.formatPhone(data.ddd_telefone_1)
      if (commercialPhone) {
        this.editedItem.commercial_phone = commercialPhone
      }

      const cellPhone = this.formatPhone(data.ddd_telefone_2)
      if (cellPhone) {
        this.editedItem.cell_phone = cellPhone
      }

      const faxPhone = this.formatPhone(data.ddd_fax)
      if (faxPhone) {
        this.editedItem.fax_phone = faxPhone
      }

      const formattedCep = this.formatCep(data.cep)
      if (formattedCep) {
        this.editedItem.zipcode = formattedCep
        this.$nextTick(() => {
          this.getCEP()
        })
      }

      this.cnpjWarningDialog = true
    },
    formatPhone(phone) {
      const digits = (phone || '').replace(/\D/g, '')
      if (digits.length === 11) {
        return `(${digits.slice(0, 2)})${digits.slice(2, 7)}-${digits.slice(7)}`
      }
      if (digits.length === 10) {
        return `(${digits.slice(0, 2)})${digits.slice(2, 6)}-${digits.slice(6)}`
      }

      return ''
    },
    formatCep(cep) {
      const digits = (cep || '').replace(/\D/g, '')
      if (digits.length !== 8) {
        return ''
      }

      return `${digits.slice(0, 2)}.${digits.slice(2, 5)}-${digits.slice(5)}`
    },
    loadCities() {
      const state = this.state_items.find(state => state.id == this.editedItem.state_id)
      if (!state) {
        this.city_items = []
        this.editedItem.city_id = ''

        return
      }

      this.get_cities(state.code).then(response => {
        this.city_items = response.data
      })
    },
    loadCitiesViaCep(localidade) {
      const state = this.state_items.find(state => state.id == this.editedItem.state_id)
      if (!state) {
        this.city_items = []
        this.editedItem.city_id = ''

        return
      }

      this.get_cities(state.code).then(response => {
        this.city_items = response.data
        const matchedCity = this.city_items.find(city => city.name == localidade)
        this.editedItem.city_id = matchedCity ? matchedCity.id : ''
      })
    },
    getCEP() {
      if (this.editedItem.zipcode.length !== 10) {
        return
      }

      const cep = this.editedItem.zipcode.replace(/\D/g, '')
      axios.get(`https://viacep.com.br/ws/${cep}/json/`)
        .then(response => {
          const { data } = response
          if (data.erro) {
            throw new Error('CEP não encontrado')
          }

          this.editedItem.address = data.logradouro || ''
          this.editedItem.neighborhood = data.bairro || ''
          this.editedItem.country_id = 31

          const matchedState = this.state_items.find(state => state.acronym == data.uf)
          this.editedItem.state_id = matchedState ? matchedState.id : ''

          if (this.editedItem.state_id) {
            this.loadCitiesViaCep(data.localidade)
          } else {
            this.city_items = []
            this.editedItem.city_id = ''
          }
        })
        .catch(() => {
          if (this.editedItem.id) {
            return
          }
          this.editedItem.address = ''
          this.editedItem.neighborhood = ''
          this.editedItem.country_id = ''
          this.editedItem.state_id = ''
          this.editedItem.city_id = ''
          this.city_items = []
        })
    },

    close() {
      this.dialog = false
      this.bookingEngineUser = null
      this.bookingEngineEmail = ''
      this.engineSetupMode = false
      this.engineSwitchState = false
      this.$nextTick(() => {
        this.editedItem = {
          ...this.defaultItem,
        }
        this.contacts = []
      })
    },
    addContact() {
      this.contacts.push({
        sector: '',
        name: '',
        email: '',
        mobile_phone: '',
        landline_phone: '',
      })
    },
    removeContact(index) {
      this.contacts.splice(index, 1)
    },
    save() {
      this.loading = true

      let billingLimit = this.editedItem.billing_limit
      if (billingLimit !== null && billingLimit !== undefined && billingLimit !== '') {
        billingLimit = Number(String(billingLimit).replace(',', '.'))
        if (Number.isNaN(billingLimit)) {
          billingLimit = null
        }
      } else {
        billingLimit = null
      }

      // Adiciona os contatos ao editedItem
      const dataToSave = {
        ...this.editedItem,
        allow_billing: Number(this.editedItem.allow_billing || 0),
        billing_limit: billingLimit,
        booking_engine_billing_enabled: !!this.editedItem.booking_engine_billing_enabled,
        booking_engine_show_billing_balance: !!this.editedItem.booking_engine_show_billing_balance,
        contacts: this.contacts,

        // Remove máscara do CNPJ
        cpf_cnpj: this.editedItem.cpf_cnpj ? this.editedItem.cpf_cnpj.replace(/\D/g, '') : null,
      }

      if (this.editedItem.id) {
        this.update(dataToSave)
          .then(response => {
            const guest = response.data
            this.close()
            this.$emit('out_data', guest)
            this.$toast.success('Salvo com sucesso !')
          })
          .catch(error => {
            if (error.response && error.response.data && error.response.data.errors) {
              const { errors } = error.response.data
              const errorMessages = Object.values(errors).flat().join('\n')
              this.$toast.error(errorMessages)
            } else {
              this.$toast.error('Erro ao salvar empresa')
            }
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.store(dataToSave)
          .then(response => {
            const guest = response.data
            this.close()
            this.$toast.success('Salvo com sucesso !')
            this.$emit('out_data', guest)
          })
          .catch(error => {
            if (error.response && error.response.data && error.response.data.errors) {
              const { errors } = error.response.data
              const errorMessages = Object.values(errors).flat().join('\n')
              this.$toast.error(errorMessages)
            } else {
              this.$toast.error('Erro ao salvar empresa')
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },

    fetchBookingEngineUser() {
      this.bookingEngineUser = null
      this.bookingEngineEmail = ''
      this.engineSetupMode = false
      this.engineSwitchState = false
      if (!this.editedItem?.id) return
      this.getBookingEngineUser(this.editedItem.id)
        .then(({ data }) => {
          this.bookingEngineUser = data
          this.bookingEngineEmail = data ? data.email : ''
          this.engineSwitchState = data?.is_active ?? false
        })
        .catch(() => {
          this.bookingEngineUser = null
          this.engineSwitchState = false
        })
    },

    handleEngineSwitch(val) {
      if (val) {
        if (!this.bookingEngineEmail) {
          this.engineSwitchState = false
          this.$toast.error('Informe o e-mail de acesso para ativar o motor.')

          return
        }

        if (!this.bookingEngineUser || !this.bookingEngineUser.is_active) {
          this.doCreateAndActivateBookingEngine()

          return
        }

        this.doToggleBookingEngine()
      } else {
        this.engineSetupMode = false
        this.engineSwitchState = false
        if (this.bookingEngineUser && this.bookingEngineUser.is_active) {
          this.doToggleBookingEngine()
        }
      }
    },

    doCreateAndActivateBookingEngine() {
      if (!this.bookingEngineEmail) return
      this.bookingEngineLoading = true
      this.saveBookingEngineEmail({ companyId: this.editedItem.id, email: this.bookingEngineEmail })
        .then(({ data }) => {
          this.bookingEngineUser = data
          this.bookingEngineEmail = data.email
          this.engineSetupMode = false
          this.engineSwitchState = true
          this.$toast.success('Motor ativado! Credenciais enviadas por e-mail.')
        })
        .catch(err => {
          this.engineSwitchState = false
          this.engineSetupMode = false
          const msg = err.response?.data?.message || 'Erro ao ativar motor'
          this.$toast.error(msg)
        })
        .finally(() => {
          this.bookingEngineLoading = false
        })
    },

    doToggleBookingEngine() {
      this.bookingEngineLoading = true
      this.toggleBookingEngine({ companyId: this.editedItem.id, email: this.bookingEngineEmail || null })
        .then(({ data }) => {
          this.bookingEngineUser = data
          this.engineSwitchState = data.is_active
          if (data.is_active) {
            this.$toast.success('Motor ativado! Credenciais enviadas por e-mail.')
          } else {
            this.$toast.success('Motor de reservas desativado.')
          }
        })
        .catch(err => {
          this.bookingEngineUser = null
          this.bookingEngineEmail = ''
          this.engineSetupMode = false
          this.engineSwitchState = false
          const msg = err.response?.data?.message || 'Erro ao alterar motor de reservas'
          this.$toast.error(msg)
        })
        .finally(() => {
          this.bookingEngineLoading = false
        })
    },

    doResendBookingEnginePassword() {
      this.bookingEngineResendLoading = true
      this.resendBookingEnginePassword(this.editedItem.id)
        .then(({ data }) => {
          this.$toast.success(data.message || 'Nova senha enviada por e-mail.')
        })
        .catch(() => {
          this.$toast.error('Erro ao reenviar senha')
        })
        .finally(() => {
          this.bookingEngineResendLoading = false
        })
    },

    doUpdateBookingEngineEmail() {
      if (!this.bookingEngineEmail) {
        this.$toast.error('Informe o e-mail de acesso.')

        return
      }

      this.bookingEngineLoading = true
      this.saveBookingEngineEmail({ companyId: this.editedItem.id, email: this.bookingEngineEmail })
        .then(({ data }) => {
          this.bookingEngineUser = data
          this.bookingEngineEmail = data.email
          this.engineSwitchState = data.is_active
          this.$toast.success('E-mail atualizado! Novas credenciais enviadas para o novo e-mail.')
        })
        .catch(err => {
          const msg = err.response?.data?.message || 'Erro ao atualizar e-mail do motor'
          this.$toast.error(msg)
        })
        .finally(() => {
          this.bookingEngineLoading = false
        })
    },
  },
}
</script>

<style scoped>
.card-tab {
    min-height: 320px;
    min-width: 736px;
}

.tool_table_fam {
    height: 50px;
}

.form-fieldset {
    border: 0;
    margin: 0;
    padding: 0;
}

.cnpj-warning-card {
    border-top: 4px solid #16B1FF;
    border-radius: 12px;
}

.cnpj-warning-title {
    color: #FFB400;
}

.cnpj-warning-text p {
    color: #4A4A4A;
}
</style>
